import { render, staticRenderFns } from "./BadgeHolderView.vue?vue&type=template&id=6f13c4ea&scoped=true"
import script from "./BadgeHolderView.vue?vue&type=script&lang=js"
export * from "./BadgeHolderView.vue?vue&type=script&lang=js"
import style0 from "./BadgeHolderView.vue?vue&type=style&index=0&id=6f13c4ea&prod&lang=css"
import style1 from "./BadgeHolderView.vue?vue&type=style&index=1&id=6f13c4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f13c4ea",
  null
  
)

export default component.exports